<section class="section-banner-service">
  <div class="banner-manage">
    <div class="img-banner">
      <img src="{{ imagen_banner }}" alt="" />
    </div>

    <div class="text-banner">
      <h1>{{"SuccessfulBooking"|translate}}</h1>
      <p>{{"BannerSucces1"|translate}}</p>
      <p>{{"BannerSucces2"|translate}}</p>
      <a [href]="toHome">
        <button class="btn-volver" mat-raised-button><strong>{{"BackToStart"|translate}}</strong></button>
      </a>
    </div>
  </div>
</section>
